module.exports = __webpack_public_path__ + "img/agreement-problems.bc026c0b.png";